import type { ReactElement } from "react";
import { createRoot, type Root } from "react-dom/client";

const componentRoots = new WeakMap<HTMLElement, Root>();

export function mountComponentRoot(node: ReactElement, rootElement: HTMLElement) {
  let root = componentRoots.get(rootElement);
  if (!root) {
    root = createRoot(rootElement);
    componentRoots.set(rootElement, root);
  }

  root.render(node);
}

export function unmountComponentRoot(element: Element) {
  if (element instanceof HTMLElement) {
    const root = componentRoots.get(element);
    if (root) {
      root.unmount();
      componentRoots.delete(element);
      return true;
    }
  }

  return false;
}
